<script>
import Register from "@/views/Registers/Register"
export default {
  name: 'UsersRegister',
  extends: Register,
  data() {
    return {
      rules: {
        required: v => !!v || 'Campo obrigatório',
        email: v => /.+@.+\..+/.test(v) || 'Formato de email inválido',
      },
      userRules: []
    }
  },
  computed: {
    computedInputsMaster() {
      return [
        { type: 'divider', label: 'Dados Básicos' },
        { type: 'switch', label: 'Ativo', value: 'active', default: true  },
        { type: 'text-field', label: 'Nome de Exibição', value: 'displayName', sm: 6,  rules: [this.rules.required] },
        { type: 'text-field', label: 'E-mail', value: 'email', sm: 6, rules: [this.rules.required, this.rules.email], validateOnBlur: true },
        { type: 'password', label: 'Senha', value: 'password', autocomplete: 'new-password', sm: 6 },
        { type: 'password', label: 'Confirmação de Senha', value: 'confirmPassword', autocomplete: 'new-password', sm: 6 },
        { type: 'text-field', label: 'Url da Foto', value: 'photoUrl' },
        
        { type: 'divider', label: 'Permissões' },
        { type: 'switch', label: 'Super Admin', value: 'claims.admin', sm: 2},
        { 
          type: 'select', 
          label: 'Papéis', 
          value: 'rules', 
          sm: 5, 
          multiple: true, 
          items: this.computedUserRules, 
          itemText: 'name', 
          itemValue: 'id', 
          disabled: 'claims.admin' 
        },
        {
          type: 'select',
          label: 'Filiais',
          value: 'companies',
          items: 'companies',
          multiple: true,
          chips: true,
          itemText: ({element}) => `${element.M0_CODIGO} - ${element.M0_NOME} - ${element.M0_CODFIL} - ${element.M0_FILIAL}`,
          itemValue: 'id',
          sm: 5,
        },
        { type: 'divider', label: 'Rotinas' },
        { type: 'switch', label: 'Enviar Login', value: 'sendEmailLogin', method: 'new', sm: 6, md: 4 },
      ]
    },
    computedDispatch() {
      return [
        {
          action: 'auth/sendSignInLinkToEmail',
          params: { email: 'item.email' },
          method: 'new',
          when: 'before',
          switch: 'sendEmailLogin'
        }
      ]
    },
    computedUserRules() {
      return this.userRules
    }
  },
  created() {
    this.userRules = this.$userRules
  }
}
</script>